var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.WxScriptModel = new Class({
    Extends: OCS.Viewer.Classes.XmlModel,
    class_name: "WxScriptModel",
    options: {},
    process: function () {
        this.build_map_options();
        this.build_map_datetime_options();
        this.build_layers();
        this.parent();
    },
    post_process: function () {
        this.options.map = {};
        this.parent();
    },
    decode_string_xml_to_json: function (str) {
        var res = this.parent(str);
        if (res.wxscript) {
            delete res.wxscript.$index;
            return res.wxscript;
        } else {
            return res;
        }
    },
    // WxScript to Json methods
    build_map_options: function () {
        var json_map = this.options.map;
        this.map_object.map = json_map['@attributes'];
        this.map_object.map.projection = json_map.projection['@attributes'].id;
    },
    build_map_datetime_options: function () {
        var loop_ops = this.options.map.loop;
        var datetime = this.get_map_datetime();
        
        var out_settings = {anchor: false, duration: datetime.time_attributes_to_milliseconds(loop_ops.duration['@attributes'])};
        if (loop_ops.anchor) {
            var time_settings = {end: datetime.get_end_epoch_time(), start: 0};
            time_settings = datetime.anchor_attributes_to_anchor(loop_ops.anchor['@attributes'], out_settings.duration);
            if (!time_settings.start) {
                time_settings.start = time_settings.end - out_settings.duration;
            }
            datetime.set_current_time_settings(time_settings);
        }

        var ocsdatetime = OCS.Functions.get_OCSDateTime();
        var datetime_duration = ocsdatetime.get_time_duration();
        if(out_settings.duration > datetime_duration) {
            ocsdatetime.set_time_duration_millsecs(out_settings.duration);
        }


        if (loop_ops.step) {
            out_settings.animation_step = datetime.time_attributes_to_milliseconds(loop_ops.step['@attributes']);
        }
        datetime.setOptions(out_settings);
        
    },
    build_layers: function () {
        var json_map = this.options.map;
        Object.each(json_map, this.build_layer.bind(this));
        this.map_object.layers = OCS.Viewer.Functions.get_utilities().array_sort_with_prop(this.map_object.layers, 'index');
    },
    build_layer: function (layer_attr, layer_key) {
        // If its not a valid layer type, return back
        if (!this.is_valid_layer_type(layer_key)) {
            return;
        }
        if (OCS.Utilities.is_array(layer_attr)) {
            layer_attr.each(function (layer) {
                this.build_layer(layer, layer_key);
            }.bind(this));
            return;
        }

        var obj = {};
        var variable = {'parm': '', 'units': ''};
        Object.each(layer_attr['@attributes'], function (value, key) {
            if (layer_key === 'shape') {
                if (key === 'feature') {
                    variable.parm = value;
                }
                if (key === 'region') {
                    variable.units = value;
                }
            } else if (layer_key === 'radar') {
                if (key === 'product') {
                    variable.parm = value;
                    this.map_object.radar.product = value;
                }
                if (key === 'site') {
                    this.map_object.radar.site = value;
                    variable.site = value;
                    variable.units = value;
                }
            } else {
                if (key === 'parm') {
                    variable.parm = value;
                }
                if (key === 'units') {
                    variable.units = value;
                }
            }
            if (key === 'min') {
                key = 'min_val';
            }
            if (key === 'max') {
                key = 'max_val';
            }
            if (key === 'color') {
                key = 'line_color';
            }
            if (key === 'labels') {
                key = 'label_contours';
            }
            obj[key] = (value === 'true') ? true : (value === 'false') ? false : value;


        }.bind(this));
        obj.variables = [];
        // Handle the wind situation
        if (layer_key === 'vector') {
            variable.parm = 'wspd';
            obj.variables.push(variable);
            obj.variables.push({'parm': 'wdir', 'units': 'degr'});
        } else {
            obj.variables = [variable];
        }

        var util = OCS.Viewer.Functions.get_utilities();
        if (!util.is_undefined(obj.location)) {
            obj.location = 4; // Forcing the location of obs to be the 4th position
        }
        obj.index = layer_attr.$index;
        obj.type = layer_key;

        if (layer_attr.colorGradient && layer_attr.colorGradient.colorKey) {
            var gradient = [];
            layer_attr.colorGradient.colorKey.each(function (val) {
                gradient.push(val['@attributes']);
            });
            obj.color_gradient = util.array_sort_with_prop(gradient, 'index');
        }
        this.map_object.layers.push(obj);
    }
}); // End OCS.Viewer.Classes.AbstractModel